// Configuration centrale - valeurs à confirmer avant prod (voir handoff README ⚠️)

// Fiche App Store (URL sans pays → ouvre le store local de l'utilisateur).
export const APP_STORE_URL = "https://apps.apple.com/app/id6764195337";

// Fiche Google Play. L'app Android est publiée depuis le 25 août 2026.
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.expedys.consumer";

/**
 * Lien unique à partager : /app redirige vers le bon magasin selon le
 * téléphone qui l'ouvre, et propose les deux sur ordinateur.
 *
 * C'est ce lien que le SMS doit contenir. Un visiteur desktop saisit son
 * numéro sans qu'on sache si le téléphone est un iPhone ou un Android :
 * envoyer l'App Store en dur enverrait la moitié des gens sur une page
 * inutilisable. Le backend le lit dans EXPEDYS_APP_DOWNLOAD_URL.
 */
export const APP_SMART_LINK = "https://expedys.com/app";

// Outils des groupeurs (pages /pro et /contact, cibles du QR du dépliant et de la carte).
export const WEB_APP_URL = "https://app.expedys.com";
// ExpedysOps n'est pas sur l'App Store : accès sur invitation (TestFlight).
// Un lien public TestFlight, s'il existe un jour, se met ici ; vide = « sur invitation ».
export const OPS_TESTFLIGHT_URL = "https://testflight.apple.com/join/SWh2dTE8";
// WeChat d'Ibrahima (cofondateur) : le QR est dans public/qr-wechat-ibrahim.png.
export const WECHAT_QR_SRC = "/qr-wechat-ibrahim.png";
// Le lien contenu dans ce QR : sur un téléphone avec WeChat, il ouvre la fiche d'Ibrahima sans scanner.
export const WECHAT_URL = "https://u.wechat.com/kMuGsoMV-8WffCppbiKcgu0?s=2";

// Backend Expedys (Render) — sert notamment à l'envoi du lien de l'app par SMS
// (endpoint POST /api/consumer/app-link/). Sans valeur, la modale SMS échoue.
export const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || "";

// Contact
export const CONTACT_EMAIL = "contact@expedys.com";
export const WHATSAPP_NUMBER = "14385440767";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
/** Lien WhatsApp avec message pré-rempli optionnel. */
export const whatsappUrl = (text?: string) =>
  text ? `${WHATSAPP_URL}?text=${encodeURIComponent(text)}` : WHATSAPP_URL;
export const PHONE = "+14385440767";
export const PHONE_DISPLAY = "+1 438 544 0767";
export const CALENDLY_URL = "https://calendly.com/contact-workless/30min";

// Réseaux sociaux (URLs à confirmer)
export const SOCIAL_LINKS = [
  { name: "Facebook", href: "https://www.facebook.com/share/1biBv5MoV5/?mibextid=wwXIfr" },
  { name: "LinkedIn", href: "https://www.linkedin.com/company/workless/" },
];

// Groupe
export const GROUP_LINKS = [
  { name: "Workless", href: "https://workless.ca" },
  { name: "Callizy", href: "https://callizy.ca" },
  { name: "Expedys", href: "https://expedys.com" },
];

// Formule indicative de l'estimateur (CAD)
export const estimatePrice = (kg: number, mode: "air" | "sea") => {
  const air = 2.6 * kg + 2.54;
  return mode === "air" ? air : air * 0.6; // ⚠️ tarif maritime -40 % non officiel
};
